import { Component, OnInit } from '@angular/core';
import { QuestionService } from '../_services/question.service';
import { CellValueChangedEvent, GridReadyEvent } from '@ag-grid-community/core';
@Component({
	selector: 'app-edit-questions',
	templateUrl: './edit-questions.component.html',
})
export class EditQuestionsComponent implements OnInit {
	rowData = [];
	rowDataPhases = [];
	columnDefs = [];
	columnDefsPhases = [];

	constructor(private QuestionService: QuestionService) {}

	ngOnInit(): void {
		this.columnDefs = [
			{
				field: 'id',
				editable: false,
				maxWidth: 60,
				type: 'numberColumn',
			},
			{
				field: 'assessmentBookId',
				editable: false,
				maxWidth: 150,
				type: 'numberColumn',

				filter: 'agNumberColumnFilter',
			},
			{
				field: 'label',
				editable: true,
				resizable: true,
				maxWidth: 300,
			},
			{ field: 'question', editable: true },
		];
		this.columnDefsPhases = [
			{
				field: 'id',
				editable: false,
				maxWidth: 60,
				type: 'numberColumn',
			},
			{
				field: 'isActive',
				editable: true,
				maxWidth: 150,
				type: 'numberColumn',

				filter: 'numberColumn',
			},
			{
				field: 'title',
				editable: true,
				resizable: true,
			},
		];

		this.QuestionService.Questions$.subscribe((data: any) => {
			var result = data.questions.map((q) => ({
				id: q.id,
				assessmentBookId: parseInt(q.assessmentBookId),
				label: q.label,
				question: q.question,
			}));

			this.rowData = result;
		});

		this.QuestionService.Phases$.subscribe((data: any) => {
			var resultPhase = data.phases.map((q) => ({
				id: q.id,
				isActive: parseInt(q.isActive),
				title: q.title,
			}));

			this.rowDataPhases = resultPhase;
		});
	}

	onCellValueChanged(event: CellValueChangedEvent) {
		this.QuestionService.updateQuestion(event.data).subscribe();
	}

	onGridReady(params: GridReadyEvent) {
		params.api.sizeColumnsToFit();
		window.addEventListener('resize', function () {
			setTimeout(function () {
				params.api.sizeColumnsToFit();
			});
		});

		params.api.sizeColumnsToFit();
	}

	onCellValueChangedPhase(event: CellValueChangedEvent) {
		this.QuestionService.updatePhase(event.data).subscribe();
	}

	onGridReadyPhase(params: GridReadyEvent) {
		params.api.sizeColumnsToFit();
		window.addEventListener('resize', function () {
			setTimeout(function () {
				params.api.sizeColumnsToFit();
			});
		});

		params.api.sizeColumnsToFit();
	}
}
